import { normalisePlatformLocale } from "../i18n/locale-registry";

// S-REBRAND-EMI موج ۱ — تنها منبعِ حقیقتِ هویتِ برند در اپِ وب.
// =====================================================================
// هر نام/دامنه/ایمیل/آیکنی که UI یا <head> نشان می‌دهد از همین‌جا می‌آید.
// هدف: موج‌های بعدی (W3 کپیِ UI، W5 دامنه) فقط همین فایل را عوض کنند، نه
// ده‌ها JSX را. `as const` است تا TypeScript مقادیر را literal نگه دارد و
// هیچ مصرف‌کننده‌ای نتواند در زمانِ اجرا برند را عوض کند.
//
// قیدها:
//   • هیچ import تصویری اینجا نیست — فقط مسیرهای رشته‌ای زیر /public.
//     (اگر import شود، این ماژول به گرافِ دارایی‌ها وصل می‌شود و chunk
//     مشترکِ تازه می‌سازد → ریسکِ گیتِ §۸٫۵ modulepreload.)
//   • رنگ‌های زیر تنها برای <meta theme-color> و manifest اند — جایی که
//     مرورگر CSS variable نمی‌پذیرد. پالتِ UI همچنان توکن‌های OKLCh است
//     (قانونِ سختِ ۷) و موج ۲ مالکِ آن است.
//   • S-REBRAND-0: پایانِ همکاری با برندِ EMI — دامنه به digiuniversity.ir
//     مهاجرت کرد. دامنهٔ پیشین (emiuniversity.ir) هیچ ری‌دایرکتی ندارد؛ فقط
//     صفحهٔ پایانِ همکاری با کدِ ۴۱۰ سرو می‌شود (نگاه کن: infra/Caddyfile.snippet).

/**
 * S-CRED-DESIGN-V2 — نامِ کاملِ دانشگاه به یک ثابتِ ماژول بالا کشیده شد تا
 * عنوانِ امضاکنندهٔ اولِ مدرک («ریاست …») از همین نام ساخته شود، نه از یک رشتهٔ
 * دومِ دست‌نویس. ریبرندِ بعدی فقط همین یک خط را عوض می‌کند و عنوانِ روی
 * دانشنامه خودبه‌خود همراهش می‌آید.
 */
const NAME_FULL_FA = "دانشگاه هوشمند ایران";
const NAME_EN = "Iranian Intelligent University";
/**
 * S-I18N-W1a-FIX — نامِ کامل به عربی. مقدارِ **موقت** و ماشینی (نه بازبینیِ
 * بومی) — استثنای آگاهانه از بندِ ۳ قاعدهٔ دوزبانگی («عربیِ دست‌نویس ممنوع،
 * فقط `i18n-translate`»): این رشته بخشِ خط‌لولهٔ ترجمهٔ `t()` نیست، برند است و
 * همین‌جا کدنویسی می‌شود، اما همان الزامِ بازبینیِ بومی رویش صادق است — به
 * همین دلیل `nameFullArNativeReviewNeeded` پایین‌تر true است تا پیش از هر
 * استفادهٔ رسمی (سربرگِ سند، ایمیل) مالک/گویشورِ بومی جایگزینش کند.
 */
const NAME_FULL_AR = "جامعة إيران الذكية";

export const BRAND = {
  // S-REBRAND-2 (۱۴۰۵/۰۵/۲۹): رفعِ همکاری با «سازمانِ متخصصین و مدیران
  // ایران» — نامِ دانشگاه و سازمانِ بهره‌بردار به هویتِ تازه (مالکیتِ کاملِ
  // مجریِ فنی) مهاجرت کرد. دلیل: تصمیمِ مالک، نه ادعای فنی.
  /** نامِ کاملِ رسمی — عنوان صفحه، og:site_name، گواهی، امضای ایمیل. */
  nameFullFa: NAME_FULL_FA,
  /** نامِ کوتاه — فعلاً برابرِ نامِ کامل (تصمیمِ مالک، موج ۱). */
  nameShortFa: NAME_FULL_FA,
  /** فرمِ فشرده برای جاهای تنگ: نوار بالا، بج، متنِ میانیِ جمله. */
  nameCompactFa: "دانشگاه هوشمند",
  /**
   * S-FIX-BRAND-1 (R2-071) — فرمِ فشردهٔ عربی. تا امروز این نام فقط در
   * `locales/ar/shell.json` زندگی می‌کرد؛ یعنی منبعِ حقیقتِ دومی که
   * `scripts/rebrand.ps1` نمی‌دیدش و ری‌برند از رویش رد می‌شد. مثلِ
   * `nameFullAr` مقدارِ ماشینی است و `nameFullArNativeReviewNeeded`
   * همچنان پرچمِ بازبینیِ بومیِ هر دو نامِ عربی است.
   */
  nameCompactAr: "الجامعة الذكية",
  /** نامِ انگلیسی — فقط جایی که متنِ لاتین لازم است (PWA، متادیتای فنی). */
  nameEn: NAME_EN,
  /** نامِ کاملِ عربی — برای locale=ar به‌جایِ nameFullFa نشان داده می‌شود. */
  nameFullAr: NAME_FULL_AR,
  /** true تا مالک/گویشورِ بومی nameFullAr را جایگزینِ مقدارِ ماشینیِ فعلی کند. */
  nameFullArNativeReviewNeeded: true as boolean,

  /**
   * زیرِ نشان در نوارِ بالا/ورود — جایگزینِ ایبرو لاتینِ قبلی
   * («AI · NATIVE · LEARNING»)؛ قانونِ سختِ ۶: متنِ کاربر-رو فارسی است.
   */
  markSubtitleFa: "پلتفرم یادگیری هوشمند",
  /** جملهٔ الزامیِ پلن (§۳٫۵) — لندینگ، دربارهٔ ما و فوتر عیناً نشانش می‌دهند. */
  platformKindFa:
    "پلتفرم یادگیری هوشمند (Intelligent Learning Platform – ILP) بر پایهٔ معماری چندعامله (Multi-Agent Architecture)",

  /**
   * یک‌خطیِ معرفی — فعلاً «—»: مالک شعارِ تازه‌ای برای برندِ جدید تعیین نکرده
   * و این فایل مجاز به ابداعِ کپی نیست (S-REBRAND-2 §۱). تا تعیینِ متنِ نهایی
   * همین‌جا می‌ماند؛ <meta name=description> از `descriptionFa` می‌خواند، نه
   * از این فیلد — پس این جای‌گزاری متای صفحه را نمی‌شکند.
   */
  taglineFa: "—",
  descriptionFa:
    "دانشگاه هوشمند ایران — آموزش عالی مبتنی بر هوش مصنوعی؛ ۸ دانشکده، ۲۴۸ برنامه، گواهی قابل اثبات.",

  // --- شبکه ------------------------------------------------------------
  // S-REBRAND-0 (۱۴۰۵/۰۵/۲۹): مهاجرتِ دامنه به digiuniversity.ir — DNS
  // (apex+www+grafana+meet روی همان VPS) + گواهیِ Let's Encrypt + دامنهٔ
  // ایمیل با هم عوض شدند.
  domain: "digiuniversity.ir",
  siteUrl: "https://digiuniversity.ir",
  email: "info@digiuniversity.ir",

  /**
   * پیشوندِ کدِ گواهی/مدرک — تنها منبعِ حقیقتِ این پیشوند (S-REBRAND-2). قرینهٔ
   * apps/api/src/brand/brand.config.ts؛ `credential-code.util.ts` رجیستری را
   * از همین‌جا می‌سازد، نه رشتهٔ hardcode. تصمیمِ مالک: بدونِ پیشوندِ قدیمی —
   * دادهٔ دموی موجود با همین موج بازنشر می‌شود.
   */
  credentialCodePrefix: "IIU",

  /**
   * سازمانِ آموزشی — دادهٔ فازِ ۱ (سندِ پلن §۳٫۵). صفحهٔ «دربارهٔ ما» و فوتر
   * از همین می‌خوانند تا معرفیِ سازمان در دو جا از هم واگرا نشود.
   *
   * عنوانِ پیشینِ این بلوک «سازمانِ مالک» بود؛ تصحیحِ مالک (۱۴۰۵/۰۵/۱۵):
   * مالکیتِ سکو و حقوقِ مادی و معنوی با `RIGHTS_HOLDER_FA` است. این بلوک
   * هویتِ سازمان را می‌دهد، نه ادعای مالکیت — هیچ متنِ کاربر-رو نباید از
   * روی آن مالکیت نتیجه بگیرد.
   */
  org: {
    // S-REBRAND-2: سازمانِ بهره‌بردارِ پیشین («سازمان متخصصین و مدیران
    // ایران») از همکاری خارج شد. هویتِ سازمانی اکنون همانِ مجریِ فنی
    // (`developer.nameFa` پایین‌تر) است — تصمیمِ مالک، نه ادغامِ حقوقی؛
    // مجوزها/شوراها/امضاکنندگان/نشانی/تلفن بدونِ تغییر ماندند («همه بمانند،
    // فقط نام عوض شود»).
    nameFa: "شرکت شبکه هوشمند ابتکار ویستا",
    nameEn: "Vista Intelligent Network",
    /** فعلاً «—»: شعارِ تازه تعیین نشده (نگاه کن به یادداشتِ taglineFa بالا). */
    sloganFa: "—",
    missionFa: "توسعهٔ آموزشِ عالیِ هوشمند و مبتنی بر هوش مصنوعی برای ایران",
    /** وضعیتِ حقوقی + مجوزها — تصمیمِ مالک: در «دربارهٔ ما» کامل بیاید. */
    legalStatusFa: "نهاد غیردولتی",
    licensesFa: [
      "مجوز کانون ارزیابی شایستگی نهاد ریاست‌جمهوری",
      "مجوز وزارت تعاون، کار و رفاه اجتماعی",
    ],
    experienceFa: "بیش از ۱۰ سال فعالیت",
    /** شوراهای تخصصی — ترتیب همان سندِ فازِ ۱ است. */
    councilsFa: [
      "شورای تخصصی هوش مصنوعی",
      "شورای تخصصی سلامت",
      "شورای تخصصی دریایی",
      "شورای تخصصی حقوقی",
      "شورای تخصصی نوآوری و گردشگری",
    ],

    /**
     * S-CRED-DESIGN — نشانی/تماسِ رسمیِ سازمان، تأییدشده توسطِ مالک. اینجاست
     * نه داخلِ کانواسِ گواهی: پانویسِ سندِ رسمی همان دادهٔ سربرگِ نامه است و
     * نباید در دو فایل واگرا شود.
     *
     * **S-CRED-DESIGN-V2 (۱۴۰۵/۰۵/۳۰):** نشانیِ تهرانِ سازمانِ پیشین با نشانیِ
     * واقعیِ سازمانِ فعلی جایگزین شد — تصمیمِ مالک. حالا یک سطر است، نه دو، چون
     * کوتاه است و شکستنش سطرِ دومِ تهی می‌ساخت؛ به‌همین دلیل کلیدها از
     * `addressFa1/Fa2` به `addressFa` تک‌سطری تغییر کردند (هر سه مصرف‌کنندهٔ
     * قبلی در همین بسته به‌روز شدند). قرینهٔ `vista.profile.ts:addressFa` است —
     * سازمان و مجریِ فنی از S-REBRAND-2 یک نهادند، پس نشانی هم یکی است.
     *
     * مصرف‌کننده‌ها: دانشنامه/گواهی، تخصص‌کارت، «تماس با ما» و فوترِ عمومی.
     */
    addressFa: "پارک علم و فناوری استان سمنان",
    addressEn: "Semnan Science and Technology Park, Semnan, Iran",
    /**
     * S-OPS-CUTOVER (۱۴۰۵/۰۶/۰۰): مقدارِ سازمانیِ صحیح از مالک دریافت شد —
     * ناسازگاریِ ثبت‌شدهٔ S-MICRO-CONFIG (تلفنِ تهران کنارِ نشانیِ سمنان) رفع شد.
     */
    telFa: "۰۲۱-۴۴۸۳۰۲۴۷",
    telEn: "+98 21 4483 0247",
    /** برای `href="tel:"` — بدونِ خط‌تیره/فاصله، قرینهٔ الگویِ `vista.profile.ts`. */
    telHref: "+982144830247",
    /**
     * ایمیلِ سازمان — هم‌زمان با `BRAND.email` در S-REBRAND-0 به دامنهٔ جدید
     * مهاجرت کرد. فیلد جدا نگه داشته شد چون *معنا*ی متفاوتی دارد: این نشانیِ
     * تماسِ سازمان روی سربرگِ سند است، نه ایمیلِ عمومیِ سامانه — اگر روزی
     * سازمان نشانیِ دیگری بخواهد، نباید به دامنهٔ سامانه گره خورده باشد.
     */
    email: "info@digiuniversity.ir",
    /**
     * امضاکنندگانِ مدرک — **تک‌منبعِ حقیقت**. قالبِ دانشنامه/گواهی فقط از همین
     * می‌خواند؛ هیچ نام/سِمَتی در JSX نیست، پس ریبرندِ بعدی به قالب دست نمی‌زند.
     *
     * **S-CRED-DESIGN-V2 (۱۴۰۵/۰۵/۳۰) — تصمیمِ مالک:** نام‌ها عوض شدند
     * (مصدری/امیدواری → بخشی)؛ سِمَتِ امضاکنندهٔ دوم عیناً همان بلوکِ دومِ
     * طراحیِ قبلی ماند و فقط سِمَتِ نفرِ اول به «ریاستِ دانشگاه» تغییر کرد و
     * **از `NAME_FULL_FA` ساخته می‌شود**، نه از یک رشتهٔ دستیِ دوم.
     *
     * شکل از تاپلِ `[نام، سِمَت]` به آبجکت تغییر کرد (خواستِ مالک): یک آرایه
     * به‌جای دو آرایهٔ موازیِ فارسی/انگلیسی — آن دو می‌توانستند از هم بیفتند.
     * ترتیب معنادار است: نفرِ اول سمتِ *شروعِ* برگه می‌نشیند.
     */
    signatories: [
      {
        nameFa: "مسعود بخشی",
        titleFa: `ریاست ${NAME_FULL_FA}`,
        nameEn: "Masoud Bakhshi",
        titleEn: `President of ${NAME_EN}`,
      },
      {
        nameFa: "محمد بخشی",
        titleFa: "معاونتِ آموزشی",
        nameEn: "Mohammad Bakhshi",
        titleEn: "Vice-President for Academic Affairs",
      },
    ],
  },

  /**
   * مجریِ فنی — فوترِ حقوقی. `legalFa` عیناً متنِ مصوبِ مالک است (پلن §۳٫۵)؛
   * تغییرِ حتی یک واژه‌اش تصمیمِ حقوقی است، نه ویرایشِ کپی.
   */
  developer: {
    nameFa: "شرکت شبکه هوشمند ابتکار ویستا",
    nameEn: "Vista Intelligent Network",
    roleFa: "طراحی، پیاده‌سازی و توسعه",
    legalFa:
      "طراحی، پیاده‌سازی و توسعه: شرکت شبکه هوشمند ابتکار ویستا — کلیهٔ حقوق مادی و معنوی این سامانه محفوظ و متعلق به شرکت شبکه هوشمند ابتکار ویستا است.",
    mark: "/logos/vista-mark-96.png",
    /**
     * پروفایلِ کاملِ شرکت (معرفی، خدمات، اکوسیستم، اعتبار، تماس) عمداً **اینجا
     * نیست**: آن داده را فقط صفحهٔ لِیزیِ `/vista` مصرف می‌کند و این فایل در
     * باندلِ اولِ هر صفحه می‌نشیند. جایش `src/brand/vista.profile.ts` است —
     * پاسِ اولِ همین کار آن را اینجا گذاشت و گیتِ اندازهٔ باندل ‎+۱۲٫۴۲KiB
     * هشدار داد. هویتِ پایه (نام/نقش/متنِ حقوقی/نشان) همین بالا می‌ماند چون
     * فوتر و پوستهٔ برنامه واقعاً همیشه به آن نیاز دارند.
     */
  },

  /** سالِ حقِ نشر در فوترها — یک عدد، نه سه رشتهٔ پراکنده. */
  copyrightYearFa: "۱۴۰۵",

  /**
   * سیاستِ اسناد — پرچم‌های برگشت‌پذیر. اینجاست و نه درونِ کامپوننت، چون
   * حاملِ یک تصمیمِ سازمانی است نه یک انتخابِ رندر.
   *
   * `showStateEmblemOnCourseCert`: نشانِ ج.ا.ا روی **گواهیِ پایانِ دورهٔ بازار**.
   * دانشنامه سندِ رسمیِ سازمان است و نشان همیشه دارد؛ گواهیِ دوره سندِ رسمیِ
   * دولتی نیست، پس این پرچم تا وصولِ مجوزِ کتبیِ سازمانی خاموش نگه داشته شد.
   * **۱۴۰۵/۰۵/۱۵ — مالک اعلام کرد تأییدیه را دارد و دستورِ روشن‌کردن داد، پس
   * روشن شد.** برگشت‌پذیر ماند: خاموش‌کردنش باز هم همین یک خط است.
   */
  certPolicy: {
    showStateEmblemOnCourseCert: true as boolean,
  },

  /**
   * S-TRUST-SEAL-SWAP — نمادهای اعتمادِ خارجی، تک‌منبعِ حقیقت برایِ
   * `trust-seals.tsx`. **کدِ اینماد وابسته به دامنه است:** با هر ریبرندِ
   * همراهِ تغییرِ دامنه، ثبت‌نامِ نمادِ تازه در پنلِ اینماد یک اقدامِ دستیِ
   * مالک است (کد فقط پس از تأییدِ سایت توسط اینماد صادر می‌شود)؛ جایگزینیِ
   * کدِ صادرشده در این مخزن فقط ویرایشِ همین دو فیلد است — به کدِ سازندهٔ
   * رشته در trust-seals.tsx دست نزن.
   */
  trustSeals: {
    enamad: {
      id: "7392499",
      code: "isGQD8doP76CHjAbLBIqPgl82fxvGzQ2",
    },
  },

  /** رنگ‌های شاسیِ مرورگر — نه توکنِ طراحی. برگرفته از لوگوی رسمی. */
  meta: {
    themeColor: "#004b8f", // سرمه‌ایِ نشان
    backgroundColor: "#0a0d1a", // splash فعلی؛ مالکِ آن موج ۲ است
    accentGold: "#ecdb00", // طلاییِ نشان — فعلاً فقط در کارتِ og
  },

  /**
   * دارایی‌های برند — با tools\brand\generate-brand-assets.ps1 از دو لوگوی
   * تازه (docs\logo\digiuniversity\logo1.png بزرگ، logo2.png کوچک) ساخته
   * می‌شوند. S-REBRAND-2: همه زیرِ /brand/... جمع شدند (پیش‌ازاین در
   * /icons، /logos، /og، /landing-v2 پخش بودند)؛ خودِ مسیر versioned است
   * (نه نامِ فایل) — همان قرارِ ضدِ کشِ ۳۰روزهٔ nginx را با پوشه‌بندی می‌دهد.
   */
  assets: {
    favicon: "/brand/icons/favicon-32.png",
    icon192: "/brand/icons/icon-192.png",
    icon512: "/brand/icons/icon-512.png",
    maskable512: "/brand/icons/maskable-512.png",
    appleTouch: "/brand/icons/apple-touch-180.png",
    ogImage: "/brand/og/og-1200x630.png",

    /**
     * موج ۳ — نشانِ درون‌برنامه‌ای. نشانِ تازه به‌قدرِ کافی روی زمینهٔ روشن و
     * تیره هر دو خوانا است (طلایی + جزئیاتِ سفیدِ درونی)، پس دو کلید محتوای
     * یکسان دارند — فقط برای سازگاریِ قراردادِ این کانفیگ نگه داشته شدند،
     * نه برای دو نسخهٔ رنگیِ واقعاً متفاوت.
     * ۹۶ برای نوارها (≤۲۸px) و ۱۹۲ برای بلوکِ ۹۶px حقوقی — هر دو ۲× رتینا.
     */
    markOnLight96: "/brand/marks/mark-96.png",
    markOnLight192: "/brand/marks/mark-192.png",
    markOnDark96: "/brand/marks/mark-on-dark-96.png",
    /**
     * لوگوی تازه (۱۴۰۵/۰۵/۳۰، docs\logo\digiuniversity\logo3.png) — فقط رویِ
     * پنلِ ورود (BrandMark3D/BrandPanel). عمداً کلیدِ جدا از markOnDark192:
     * آن کلید در OrgAttribution و ExpertiseCardCanvas هم مصرف می‌شود و مالک
     * فقط لندینگ+ورود را خواسته، نه فوتر/کارتِ تخصص/گواهی را.
     */
    markLogin192: "/brand/marks/mark-login-192.png",
    markOnDark192: "/brand/marks/mark-on-dark-192.png",
    /**
     * موج ۴ — نشانِ تک‌رنگِ سرمه‌ای برای سربرگِ گواهی. نسخهٔ چندرنگ اینجا کار
     * نمی‌کند: جزئیاتِ گرادیانی در چاپِ سیاه‌وسفید محو می‌شوند. ۱۹۲ چون گواهی
     * در A4 با ۳۰۰dpi چاپ می‌شود، نه اندازهٔ CSS.
     */
    markPrint192: "/brand/marks/mark-print-192.png",
    /**
     * S-CRED-DESIGN-V2 — **واترمارکِ مرکزیِ برگهٔ مدرک.** تصمیمِ مالک
     * (۱۴۰۵/۰۵/۳۰): از **logo2** (نشانِ کوچک) باشد، نه از logo1 که سربرگ و مُهر
     * از آن ساخته شده‌اند — تکرارِ سه‌بارهٔ یک نشان در یک برگه بصری زائد بود.
     * فایل همان خروجیِ `Save-Mark $img2 192` است (تولیدِ خطِ «marks (logo2)» در
     * toolsrand\generate-brand-assets.ps1)، پس دارایی تازه‌ای اضافه نمی‌شود.
     * کلید عمداً جداست تا عوض‌کردنِ هنرِ واترمارک یک خط بماند و سربرگ/مُهر را
     * با خود نبرد.
     */
    certWatermark192: "/brand/marks/mark-192.png",
    /**
     * S-CRED — نشانِ رسمیِ جمهوری اسلامی ایران. فقط روی اسنادِ رسمی می‌نشیند
     * (دانشنامه، و رویِ تخصص‌کارت — از موجِ W3 عرضه شده)، نه در رابطِ کاربری: نشانِ
     * دولتی روی یک دکمه یا نوار، ادعای مرجعیتی است که آنجا وجود ندارد.
     * دو نسخه چون نشان روی کاغذِ سفید جوهری و روی زمینهٔ سرمه‌ای روشن است.
     */
    stateEmblem192: "/logos/iri-emblem-192.png",
    stateEmblemOnDark192: "/logos/iri-emblem-on-dark-192.png",
    /**
     * امضای «دانشگاه هوشمند ایران» — تنها نوشتار، بی‌نشان (از
     * docs\logo\digiuniversity\logo-text.png، جای‌گزینِ امضای پیکسلیِ برندِ
     * پیشین). زیرِ نشانِ متحرکِ پنلِ ورود می‌نشیند تا مجموع، همان لاک‌آپِ رسمی
     * خوانده شود. نسخهٔ on-dark سفید است (سرمه‌ای روی پنلِ #0d1f44 دیده
     * نمی‌شود).
     */
    wordmarkOnDark720: "/brand/marks/wordmark-on-dark-720.png",
    wordmarkOnLight720: "/brand/marks/wordmark-720.png",
    /** لاک‌آپِ کاملِ رسمی (نشان + امضا) — برای سربرگ و کاربردهای تک‌تصویری. */
    lockupOnDark512: "/brand/marks/lockup-on-dark-512.png",
    lockupOnLight512: "/brand/marks/lockup-512.png",
    /**
     * لاک‌آپِ هیروِ لندینگ — همین تصویر LCP صفحه است.
     * ۱۴۰۵/۰۵/۳۰ — از logo3.png بازتولید شد (تنها مصرف‌کنندهٔ این کلید
     * Home.tsx است، پس این فایل مستقیم جایگزین شد، بدونِ کلیدِ جدا).
     */
    heroLockup: "/brand/landing/hero-lockup.png",
  },
} as const;

/**
 * A brand proper name is not machine-translated with the surrounding UI.
 * Persian and Arabic use their explicitly governed forms; every other
 * registered locale uses the existing official English form. Unknown input
 * follows the platform's Persian fallback instead of inventing a locale.
 */
export const brandNameForLocale = (raw: unknown): string => {
  const locale = normalisePlatformLocale(raw);
  if (locale === "ar") return BRAND.nameFullAr;
  if (locale === "fa" || !locale) return BRAND.nameFullFa;
  return BRAND.nameEn;
};

export const brandCompactNameForLocale = (raw: unknown): string => {
  const locale = normalisePlatformLocale(raw);
  if (locale === "ar") return BRAND.nameCompactAr;
  if (locale === "fa" || !locale) return BRAND.nameCompactFa;
  return BRAND.nameEn;
};

/**
 * دارندهٔ حقِ نشر — **تصمیمِ صریحِ مالک (۱۴۰۵/۰۵/۱۵)**: مالکیتِ مادی و معنویِ
 * وب‌سایت، نشان‌های تجاری و محتوای آن با **مجریِ فنی** است، نه با سازمان.
 * سازمان بهره‌بردار است و نام و نشانش در فوتر و «دربارهٔ ما» سرِ جای خود می‌ماند؛
 * آنچه عوض شد فقط جملهٔ حقِ نشر است.
 *
 * یک منبعِ حقیقت برای هر سه فوتر (عمومی، ورک‌اسپیس، جریانِ ورود) **و بندِ
 * مالکیتِ صفحهٔ «دربارهٔ ما»** — رشته‌های جدا یعنی روزی یکی‌شان جا می‌مانَد و
 * سایت دو ادعای حقوقیِ متناقض می‌دهد. دقیقاً همین رخ داد: فوترها در پاسِ اول
 * اصلاح شدند ولی «دربارهٔ ما» هنوز می‌گفت سکو محصولِ سازمان است.
 * تغییرِ این مقدار تصمیمِ حقوقی است، نه ویرایشِ کپی.
 */
export const RIGHTS_HOLDER_FA: string = BRAND.developer.nameFa;

/** og:image باید برای خزنده‌ها مطلق باشد؛ همان مبدأ خودمان، نه CDN. */
export const ogImageUrl = (): string => BRAND.siteUrl + BRAND.assets.ogImage;

export type Brand = typeof BRAND;
